export default "__VITE_ASSET__oRaknIIs__"